import React, { Component } from "react";
import "../style/home.scss";
import "swiper/scss";
import "swiper/scss/navigation";
import "swiper/scss/pagination";
import HeaderBar from "./common/HeaderBar";
import FooterBar from "./common/FooterBar";
import { productList, getCategoryList } from "../apis/GetProduct";
import swiper1 from "../image/swiper1.webp";
import swiper2 from "../image/swiper2.webp";
import swiper3 from "../image/swiper3.webp";
import swiper4 from "../image/swiper4.webp";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/scss";
import "swiper/scss/navigation";
import "swiper/scss/pagination";
import "swiper/scss/autoplay";
import moment from "moment";

import sec3 from "../image/sec3.webp";
import sec3_1 from "../image/sec3-1.webp";
import sec1 from "../image/sec1.jpg";
import { Rate } from "antd";
import sec2 from "../image/sec2.png";
import sec2_1 from "../image/sec2-1.png";
import sec2_2 from "../image/sec2-2.png";
import sec2_3 from "../image/sec2-3.png";
import sec5 from "../image/sec5.webp";
import sec5_1 from "../image/sec5-1.webp";
import f_circle from "../image/f-circle.png";
import sec6 from "../image/sec6.png";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      swiperList: [
        {
          title: "Hillary , TX",
          text: "“I love The Sill! It’s a nice way to send plants to people you love who live far away. Thanks for helping me stay connected!”",
          img: swiper1,
        },
        {
          title: "Melanie , IL",
          text: "“My Monstera arrived gorgeous and healthy!!! Best looking plant I’ve ever pulled out of a box!!”",
          img: swiper2,
        },
        {
          title: "Kelsey , CA",
          text: "“I have ordered several times and each time I get the healthiest, prettiest plants very quickly. I have been extremely satisfied with The Sill.”",
          img: swiper3,
        },
        {
          title: "Molly , CO",
          text: '"Thank you so much for getting back to me about my plant concern! I’m grateful that customer service does still exist <3 Can’t wait to recommend The Sill to others !"',
          img: swiper4,
        },
      ],

      date: moment(new Date()).format("DD/M/YY"),
    };
    this.routePage = this.routePage.bind(this);
    this.hoverChange = this.hoverChange.bind(this);
    this.routeProductDetail = this.routeProductDetail.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  routePage(type) {
    let { history } = this.props;
    switch (type) {
      case "home":
        history.push("/");
        break;
      case "about":
        history.push("/About");
        break;
      case "pricing":
        history.push("/Pricing");
        break;
      case "contact":
        history.push("/Contact");
        break;
      default:
        break;
    }
  }

  hoverChange(index) {
    let { productList } = this.state;
    productList[index].isHover = !productList[index].isHover;
    this.setState({ productList });
  }

  routeProductDetail(id) {
    let { history } = this.props;
    history.push(`/ProductDetail/${id}`);
  }

  render() {
    let { swiperList, sec6Arr, date } = this.state;
    let category1 = getCategoryList("Our favourite finds on Folksy");
    let category2 = getCategoryList("Theme of the day: Carved By Hand");
    let category3 = getCategoryList("Donate to Charity");
    let sec2Arr = [
      { img: sec2 },
      { img: sec2_1 },
      { img: sec2_2 },
      { img: sec2_3 },
    ];

    return (
      <React.Fragment>
        <HeaderBar {...this.props} />
        <div className="home-page">
          <div className="sec1">
            <div className="img">
              <img src={sec1} alt="" />
            </div>
            <div className="mask">
              <p>
                The UK's Biggest Online Craft Fair <br />
                Folksy is the home of British craft - the place to buy handmade{" "}
                <br />
                gifts and original artwork, sold directly by the artists and{" "}
                <br />
                designers who have created them. Made with love, every purchase{" "}
                <br />
                from Folksy supports a genuine craftsperson.
              </p>
            </div>
          </div>
          <div className="sec2">
            <div className="head">
              <div className="circle">
                <img src={f_circle} alt="" />
              </div>
            </div>
            <div className="contain">
              {sec2Arr.map((item, index) => {
                return (
                  <div className="col" key={index}>
                    <div className="img">
                      <img src={item.img} alt="" />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="sec4">
            <div className="head">
              <div className="circle">
                <img src={f_circle} alt="" />
              </div>
            </div>
            <div className="title">{category1?.category}</div>
            <div className="row">
              {category1?.list?.map((item, index) => {
                return (
                  <div
                    className="col"
                    key={index}
                    onClick={() => this.routeProductDetail(item.id)}
                  >
                    <div className="img-box">
                      {item.isHover ? (
                        <img src={item.image[1]} lt="" />
                      ) : (
                        <img src={item.image[0]} lt="" />
                      )}
                    </div>
                    <div className="txt">
                      <div className="title">{item.title}</div>
                      <div className="star">
                        <Rate
                          disabled
                          defaultValue={5}
                          style={{ fontSize: 14, color: "#f15b40" }}
                        />
                      </div>
                      <div className="tool">
                        <div className="price">￡{item.price}</div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="sec4">
            <div className="head">
              <div className="circle">
                <img src={f_circle} alt="" />
              </div>
            </div>
            <div className="title">{category2?.category}</div>
            <div className="row">
              {category2?.list?.map((item, index) => {
                return (
                  <div
                    className="col"
                    key={index}
                    onClick={() => this.routeProductDetail(item.id)}
                  >
                    <div className="img-box">
                      {item.isHover ? (
                        <img src={item.image[1]} lt="" />
                      ) : (
                        <img src={item.image[0]} lt="" />
                      )}
                    </div>
                    <div className="txt">
                      <div className="title">{item.title}</div>{" "}
                      <div className="star">
                        <Rate
                          disabled
                          defaultValue={5}
                          style={{ fontSize: 14, color: "#f15b40" }}
                        />
                      </div>
                      <div className="tool">
                        <div className="price">￡{item.price}</div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="sec4">
            <div className="head">
              <div className="circle">
                <img src={f_circle} alt="" />
              </div>
            </div>
            <div className="title">{category3?.category}</div>
            <div className="row">
              {category3?.list?.map((item, index) => {
                return (
                  <div
                    className="col"
                    key={index}
                    onClick={() => this.routeProductDetail(item.id)}
                  >
                    <div className="img-box">
                      {item.isHover ? (
                        <img src={item.image[1]} lt="" />
                      ) : (
                        <img src={item.image[0]} lt="" />
                      )}
                    </div>
                    <div className="txt">
                      <div className="title">{item.title}</div>{" "}
                      <div className="star">
                        <Rate
                          disabled
                          defaultValue={5}
                          style={{ fontSize: 14, color: "#f15b40" }}
                        />
                      </div>
                      <div className="tool">
                        <div className="price">￡{item.price}</div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="sec6">
            <img src={sec6} alt="" />
          </div>
          <div className="sec7">
            <div className="head">
              <div className="circle">
                <img src={f_circle} alt="" />
              </div>
            </div>
            <div className="title">The Home of British Craft</div>
            <p>
              Folksy is the home of British Craft. On our pages you will find
              thousands of pieces created by artists, designers and makers,
              knitting, stitching, painting, printing, soldering, sketching,
              whittling, carving and crocheting in studios and at kitchen tables
              across the UK.
            </p>
            <p>
              So if you’re looking for that perfect original gift or you want to
              shop small, shop independent and give handmade, we suggest sitting
              down with a cuppa and having a look through the amazing creations
              on Folksy - all made by clever hands crafting away across the
              British Isles.
            </p>
            <p>
              So if you’re looking for that perfect original gift or you want to
              shop small, shop independent and give handmade, we suggest sitting
              down with a cuppa and having a look through the amazing creations
              on Folksy - all made by clever hands crafting away across the
              British Isles.
            </p>
          </div>
        </div>
        <FooterBar {...this.props} />
      </React.Fragment>
    );
  }
}

export default Home;
